import type { BookCardBook } from '@/components/books/book-card';

export function computeTogglePinned(ids: readonly string[], bookId: string): string[] {
    const index = ids.indexOf(bookId);
    if (index >= 0) {
        return ids.filter((_, i) => i !== index);
    }
    return [bookId, ...ids];
}

export function orderPinnedBooks(allBooks: BookCardBook[], pinnedIds: string[]): BookCardBook[] {
    const byId = new Map(allBooks.map(book => [book.id, book]));
    const ordered: BookCardBook[] = [];
    for (const id of pinnedIds) {
        const book = byId.get(id);
        if (book) {
            ordered.push(book);
        }
    }
    return ordered;
}
